<template>
  <b-tabs>
    <b-tab active title="Info">
      <b-container :fluid="true" align="center" justify="center">
        <b-row>
          <b-col class="text-right"> Backend</b-col>
          <b-col class="text-left"> {{ backend }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> Front version:</b-col>
          <b-col class="text-left"> {{ frontVersion }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> Front b-tag:</b-col>
          <b-col class="text-left"> {{ frontBuildTag }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> API version:</b-col>
          <b-col class="text-left"> {{ backendVersion.version }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> API b-tag:</b-col>
          <b-col class="text-left"> {{ backendVersion.buildTag }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> PySvc version:</b-col>
          <b-col class="text-left"> {{ backendVersion.pySvcVersion }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> PySvc b-tag:</b-col>
          <b-col class="text-left"> {{ backendVersion.pySvcBuildTag }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-right"> EventBus subscriptions:</b-col>
          <b-col class="text-left"> {{ eventBusSubs }}</b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col class="text-right"> Subscription status:</b-col>
          <b-col class="text-left"> {{ subStatus }}</b-col>
        </b-row>

        <b-row class="pt-1 border-top">
          <b-col>
            <b-form-checkbox
                v-model="streaming"
                @change="configStream"
            >
              Streaming Grid
            </b-form-checkbox>
          </b-col>

          <b-col>
            <b-button @click="techFlags">
              Turn on technical Feature Flags
            </b-button>
           </b-col>
        </b-row>

        <b-row class="pt-1 border-top">
          <b-col>
            <b-form-checkbox
                v-model="logSuccessful"
                @change="configLogs"
            >
              Log successful communication
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-select v-model="logLevel" :options="logLevels" @change="configLogs"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
                class="pt-2"
                @click="resetAllCaches"
            >
              Reset All Caches
            </b-button>
          </b-col>
        </b-row>
        <!--        TODO wysypuje dockera z API na każdym środowisku, zostawiam póki co włączonego lokalnie-->
        <b-row v-if="isDev" class="pt-3">
          <b-col>
            <b-button
                class="pt-2"
                @click="resetAllTranslations"
            >
              Reset Translations
            </b-button>
          </b-col>
        </b-row>
        <b-row class="pt-5">
          <b-col class="pt-1  text-right">
            Memory Bombs (window['_mem_bombs']) {{ bombs }}
          </b-col>
          <b-col class="pt-1">
            <b-btn color="success" style="width: 200px" @click="toggleBombs">On/Off</b-btn>
          </b-col>

        </b-row>
        <b-row class="pt-5">
          <b-col class="pt-1  text-right">
            Delay in ms:
          </b-col>
          <b-col class="pt-1">
            <b-input v-model="delay" label="Delay in ms"></b-input>
          </b-col>
          <b-col class="pt-1 text-left">
            <b-btn color="success" style="width: 200px" @click="setDelay">Set delay</b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-left"> ASYNC TASK TEST: {{ asyncTaskResults }}</b-col>
        </b-row>
        <b-row>
          <b-col class="text-left"> CELERY ASYNC TASK TEST: {{ asyncTaskResults2 }}</b-col>
        </b-row>
      </b-container>
    </b-tab>
    <b-tab title="Permissions">
      <SessionInfoTab></SessionInfoTab>
    </b-tab>

    <b-tab title="Export/import">
      <ExportImport></ExportImport>
    </b-tab>
    <b-tab title="Multiselect Tests">
      <MultiselectTest></MultiselectTest>
    </b-tab>
    <b-tab title="PillsList Tests">
      <TextPillsListTest></TextPillsListTest>
    </b-tab>

    <b-tab title="AI test">
      <AITest></AITest>
      <NewBlackAITest></NewBlackAITest>
    </b-tab>

    <b-tab title="Multiselect List">

      <MultiselectList
          v-model="selectedItems"
          :all-items="allItems"
          @delete-item="deleteItemFromSelectedItems"
          @add-item="addItemToSelectedItems"
          ref="multiselectList"
          left-label="Selected items"
          right-label="Available items"
          label-field="name_pl"
      ></MultiselectList>

    </b-tab>
    <b-tab title="TipTap">
      <div class="container">
        <div class="row">
          <div class="col">
            <FormattedInput v-model="tipTapContent" height="200"></FormattedInput>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span v-html="tipTapContent"></span>
          </div>
        </div>
      </div>
    </b-tab>
    <b-tab title="TreeView">

      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 py-3">
            <TreeViewCard :title="$tr('departments','Departments')"
                          breakpoint="md"
                          :stretch-height="true"
                          :alternate-height="300"

                          :data="treeData" ref="tree" v-model="treeSelection"></TreeViewCard>
          </div>
          <div class="col-6">
            <span v-html="treeSelection ? treeSelection.name : ''"></span>
          </div>
        </div>
      </div>

    </b-tab>
    <b-tab title="Templates">
      <b-button @click="templateSimple">{{$tr('simpleTemplate','Simple template')}}</b-button>
      <b-button @click="templateRecordEdit">{{$tr('recordEdit','Record edit')}}</b-button>
      <b-button @click="templateRecordEditNew">{{$tr('recordEdit-New','Record edit - new')}}</b-button>
      <b-button @click="templateGrid">{{$tr('gridTemplate','Grid template')}}</b-button>
      <b-button @click="templateFreeForm">{{$tr('freeFormTemplate','Free form template')}}</b-button>
      <b-button @click="templateComplex">{{$tr('ComplexFormTemplate','Complex form template')}}</b-button>

      <b-button @click="templateFormList">{{$tr('formListTemplate','FormList template')}}</b-button>
    </b-tab>
  </b-tabs>
</template>


<script>
import Activity from "@/activity/Activity";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import FileUpload from "@/components/FileUpload";
import Rpc from "@/Rpc";
import VBox from "@/components/VBox";
import ApplicationVersion from "@/server/com/silkplm/rpc/dto/ApplicationVersion";
import Log from "@/utils/Log";
import RpcClass from "@/server/RpcClass";
import Multiselect from "@/components/inputs/controls/Multiselect";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import MultiselectTest from "@/components/console/MultiselectTest";
import TextPillsListTest from "@/components/console/TextPillsListTest";
import SmartSearch from "@/components/dashboard/SmartSearch";
import MultiselectList from "@/components/list/MultiselectList";
import FormattedInput from "@/components/inputs/controls/FormattedInput";
import TreeView from "@/components/tree/TreeView";
import TreeViewCard from "@/components/tree/TreeViewCard";
import SessionInfoTab from "@/components/console/SessionInfoTab";
import ReachIntInput from "@/components/inputs/ReachIntInput";
import ColorSelectRenderer from "@/components/forms/renderers/ColorPickerRenderer";
import {setStreamingOn} from "@/components/datagrid/StreamingGrid";
import AITest from "@/components/console/AITest.vue";
import ExportImport from "./ExportImport.vue"
import CacheManager from "@/components/cacheManager/CacheManager";
import SessionManager from "@/utils/SessionManager";
import NewBlackAITest from "@/components/console/NewBlackAITest.vue";


const ComplexActivity = () => require("@/activity/templates/ComplexActivityTemplate");
const RecordEdit = () => require("@/activity/templates/RecordEditActivityTemplate");
const SimpleActivity = () => require("@/activity/templates/SimpleActivityTemplate");
const GridActivity = () => require("@/activity/templates/GridActivityTemplate");
const FreeFormActivity = () => require("@/activity/templates/FreeFormActivityTemplate");
const FormListActivity = () => require("@/activity/templates/FormListActivityTemplate");


export default {
  name: "ConsoleActivity",
  components: {
    NewBlackAITest,
    AITest,
    ColorSelectRenderer,
    ReachIntInput,
    ExportImport,
    SessionInfoTab,
    TreeViewCard,
    FormattedInput,
    MultiselectList,
    SmartSearch,
    TreeView,
    TextPillsListTest, MultiselectTest, TextPillsList, Multiselect, VBox, DataGrid2, FileUpload
  },

  async mounted() {
    this.$refs.tree.expand(10);
    this.$subscribe("tic-toc", console.log);

    this.startTask2();
    let task = await Rpc.healthcheck.AsyncApi.generateText();
    task.onPartialResult(partialResult => {
      this.asyncTaskResults = partialResult;
    });
    let finished = await task.finish();

    this.asyncTaskResults = "DONE:" + finished;
  },

  async created() {
    // console.log(await Rpc.PySvc.call("sample_rpc", "hello_user_with_args", ["aaa", 15]));

    this.backendVersion = await Rpc.Interactions.backendVersion();

    let arr = [];

    for (let i = 0; i < 100; i++) {
      arr.push({'id': i, 'phone': "345-" + i, rand: Math.random()});
    }
    this.lists = arr;

    // await Rpc.healthcheck.AiApiTest.test();
  },


  methods: {

    ...Activity.methods,

    templateRecordEdit(){
      ActivityManager.replaceActivity(RecordEdit);
    },
    templateRecordEditNew(){
      ActivityManager.replaceActivity(RecordEdit, {createMode:true});
    },
    templateGrid(){
      ActivityManager.replaceActivity(GridActivity);
    },
    templateSimple(){
      ActivityManager.replaceActivity(SimpleActivity);
    },
    templateFreeForm(){
      ActivityManager.replaceActivity(FreeFormActivity);
    },
    templateComplex(){
      ActivityManager.replaceActivity(ComplexActivity);
    },
    templateFormList(){
      ActivityManager.replaceActivity(FormListActivity);
    },


    async startTask2(){
      let task = await Rpc.healthcheck.AsyncApi.celeryEcho();
      task.onPartialResult(partialResult => {
        this.asyncTaskResults2 = partialResult;
      });
      let finished = await task.finish();
      this.asyncTaskResults2 = "DONE" + finished;

    },
    report() {
      // console.log("zzz:" + this.filterInput);
    },

    multipleInstances() {
      return Activity.BUBBLE;
    },

    sendNotification() {
      Rpc.healthcheck.Notifications.echo(this.echoMsg);
    },
    sendNotificationX() {
      this.sendNotificationY();
    },
    sendNPE() {
      Rpc.healthcheck.methods.ExposedMethods.npeExceptionMethod();
    },

    getTitle() {
      return "Console";
    },

    async open() {
      let activity = ActivityManager.showActivity(SampleActivity);
      let result = await activity.getResult();
      if (result != null) {
        this.result = result;
      }
    },

    goToRow() {
      let n = parseInt(this.filterInput);
      this.$refs['grid'].focusOnIndex(n);
    },

    configStream(){
      localStorage.setItem("streaming.on", this.streaming);
      setStreamingOn(this.streaming);
    },

    techFlags(){
      window['__technical_flags'] = 1;
    },

    configLogs() {
      Log.debugLevel = this.logLevel;
      RpcClass.logSuccessful = this.logSuccessful;
      localStorage.setItem("log.level", this.logLevel);
      localStorage.setItem("log.logSuccessfulRpc", this.logSuccessful);
    },

    deleteItemFromSelectedItems(index) {
      let selectedItem = this.selectedItems[index];
      this.allItems.push(selectedItem);
      this.selectedItems.splice(index, 1);
    },

    addItemToSelectedItems(index) {
      let selectedItem = this.allItems[index];
      this.selectedItems.push(selectedItem);
      this.allItems.splice(index, 1);
    },
    async setDelay() {
      let num = parseInt(this.delay);
      await Rpc.healthcheck.Selenium.setDelay(num);
    },

    toggleBombs(){
      window['_mem_bombs'] = !window['_mem_bombs'];
      this.bombs = window['_mem_bombs'];
    },

    async resetAllCaches(){
      await Rpc.plm.services.CacheServiceRpc.resetAllCaches();
      await DialogManager.info($tr('cacheResetSuccessfully','Cache reset successfully.'),
          $tr('allCachesSuccessfullyReset','All caches successfully reset.'));
      CacheManager.reset();
    },
    async resetAllTranslations() {
      await Rpc.plm.services.CacheServiceRpc.resetAllTranslations();
      await DialogManager.info($tr('translationsResetSuccessfully', 'Translations reset successfully.'),
          $tr('translationsResetSuccessfully', 'Translations reset successfully.'));
    }
  },

  data() {
    return {
      isDev: SessionManager.isDev(),
      bombs: !!window['_mem_bombs'],
      backend: window["_apiEndpoint"],
      /** @type {ApplicationVersion} */
      backendVersion: new ApplicationVersion(),
      delay: "0",
      frontVersion: (window['_frontendVersion'] || '?'),
      frontBuildTag: (window['_frontendBuildTag'] || '?'),
      echoMsg: "",
      lists: [{'phone': "123"}, {'phone': "345"}],
      fields: [
        {name: 'rand', prop: 'rand', sortable: true},
        {
          name: 'Phone', prop: 'phone', autoSize: true, size: 110, sortable: true,
          template: "<div>XX {{model[prop]}} {{column}}</div>"
        }
      ],
      filterInput: "",

      logLevels: [
        {value: -1, text: "-1: Only warnings & errors"},
        {value: 0, text: "0: Info, warnings & errors"},
        {value: 2, text: "2: Debug, info, warnings & errors"},
        {value: 3, text: "3: Trace, debug, info, warnings & errors"},
      ],
      logSuccessful: RpcClass.logSuccessful,
      logLevel: Log.debugLevel,
      streaming: !!localStorage.getItem("streaming.on"),
      selectedItems: [],
      allItems: [],
      asyncTaskResults: "",
      asyncTaskResults2: "",
      tipTapContent: '',
      treeData: [{
        "id": 2, "name": "Venus", "children":
            [{"id": 3, "name": "Neptune"},
              {"id": 4, "name": "Stratus-4"},
              {"id": 5, "name": "Stratus-5"},
              {
                "id": 6, "name": "Stratus-6", "children": [
                  {"id": 8, "name": "Stratus-7-1"},
                  {"id": 9, "name": "Stratus-7-2"},
                ]
              },
              {"id": 7, "name": "Stratus-7"},
            ]
      }],
      eventBusSubs: EventBus.subscribed,
      treeSelection: null,
      subStatus: `Subscription: ${SessionManager.organizationSubscriptionType} | ${SessionManager.userSubscriptionStatus} | ${SessionManager.userSubscriptionType}`
    };
  },

};


</script>